<template>
    <main class="page">
        <!-- Banner -->
        <motor-banner v-if="main" :bgimg="{
            src: env.imageUrl + main.banner.banner_about.image,
            loading: env.imageUrl + main.banner.banner_about.thumb_image,
        }" title="about us" />
        <div class="motor-container" v-if="about">
            <!-- Section -->
            <section class="section section--experience">
                <div class="media" v-lazy:background-image.container="{
                    src: env.imageUrl +  about.about_header.image,
                    loading: env.imageUrl + about.about_header.thumb_image,
                }"></div>
                <div class="experience">
                    <h2>{{about.about_header.title}}</h2>
                    <p>{{about.about_header.description}}</p>
                </div>
            </section>
            <section class="section section--founded">
                <h2>{{about.about_body.title}}</h2>
                <p>{{about.about_body.description}}</p>
            </section>
            <section class="section section--media" v-lazy:background-image.container="{
                    src: env.imageUrl +  about.about_body.image,
                    loading: env.imageUrl + about.about_body.thumb_image,
                }">
            </section>
            <section class="section section--vision-mision">
                <article class="article article--history">
                    <h2>History</h2>
                    <p>{{about.about_goal.history}}</p>
                </article>
                <article class="article article--history">
                    <h2>Vision</h2>
                    <p>{{about.about_goal.vision}}</p>
                </article>
                <article class="article article--history">
                    <h2>Mission</h2>
                    <p>{{about.about_goal.mission}}</p>
                </article>
            </section>
        </div>
        <!-- Footer -->
        <motor-footer :data="main" />
    </main>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import { env } from '../enviorments'

import MotorBanner from '@/components/MotorBanner.vue'
import BannerImg from '@/assets/images/home-banner.jpg'

export default {
    name: 'about',
    components: {
        MotorBanner,
    },
    data() {
        return {
            BannerImg,
            env,
        }
    },
    computed: {
        ...mapState({
            main: state => state.main,
            about: state => state.about,
        })
    },
    methods: {
        ...mapActions({
            callMain: 'callMain',
            callAbout: 'callAbout',
        })
    },
    async mounted() {
        if (!this.main) await this.callMain()
        if (!this.about) await this.callAbout()
        console.log(this.main, this.about)
    }
}
</script>

<style lang="scss" scoped>
.page {
    // padding: 100px;
    .motor-container {
        padding: 60px 0;
        h2 {
            font-weight: 300;
            @media (min-width: 768px) {
                font-size: 2.2rem;
            }
            @media (min-width: 992px) {
                font-size: 2.5rem;
            }
        }
        .section--experience {
            @media (min-width: 992px) {
                display: flex;
            }
            .media {
                width: 100%;
                height: 200px;
                background-color: var(--primary);
                background-image: url(../assets/images/about-image.png);
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                @media (min-width: 992px) {
                    flex: 1;
                    height: initial;
                    position: relative;
                    overflow: hidden;
                    &::after {
                        content: '';
                        display: block;
                        position: absolute;
                        z-index: 1;
                        top: 0;
                        right: 0;
                        width: 200px; 
                        height: 200%; 
                        background-color: #fff;
                        transform-origin: top left;
                        transform: translate(100%, 0) rotate(15deg);
                    }
                }
            }
            .experience {
                padding: 40px 20px 20px;
                max-width: 600px;
                margin: 0 auto;
                @media (min-width: 992px) {
                    flex: 1;
                    padding: 60px 20px;
                }
            }
        }
        .section--founded {
            padding: 20px;
            text-align: center;
            max-width: 600px;
            margin: 0 auto;
            @media (min-width: 992px) {
                max-width: 800px;
                padding: 60px 20px;
            }
        }
        .section--media {
            padding: 0;
            height: 300px;
            background-color: var(--primary);
            background-repeat: no-repeat;
            background-size: cover;
            @media (min-width: 768px) {
                height: 400px;
            }
        }
        .section--vision-mision {
            padding: 40px 0 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            .article {
                width: 100%;
                max-width: 400px;
                text-align: center;
                padding: 20px;
            }
        }
    }
}
</style>
